"use strict";

exports.__esModule = true;
exports.createDownloadCellFormatter = createDownloadCellFormatter;
var _columnFormatters = require("./columnFormatters");
var _Formatters = require("../../Widgets/DataTable/Formatters");
var _ticketing = require("../../Widgets/DataTable/Formatters/ticketing");
var _device = require("../../Widgets/DataTable/Formatters/device");
function createDownloadCellFormatter(_ref) {
  var column = _ref.column,
    translate = _ref.translate,
    time = _ref.time,
    devices = _ref.devices,
    plantStateActivities = _ref.plantStateActivities,
    ticketTypes = _ref.ticketTypes,
    users = _ref.users,
    devicesMap = _ref.devicesMap;
  return function (row) {
    if (_columnFormatters.formattableTypes.includes(column.type)) {
      if (column.type === "trendline") {
        return null;
      }
      if (column.type === "lookUpForTypeInRow") {
        var cellValue = row[column.id];
        var cellType = row[column.id + ".type"];
        if (cellType === "duration") {
          return cellValue / 1000;
        }
        if (cellType === "fractionalPercent") {
          return parseFloat(parseFloat(row[column.id]).toFixed(4));
        }
        return cellValue;
      }
      if (column.type === "duration") {
        return row[column.id] / 1000;
      }
      if (column.type === "hour") {
        var value = row[column.id];
        return Number(value) >= 0 && Number(value) < 10 ? "0" + value + ":00" : value + ":00";
      }
      if (column.type === "fractionalPercent") {
        return parseFloat(parseFloat(row[column.id]).toFixed(4));
      }
      if (column.type === "ticketTypes") {
        return (0, _ticketing.formatTicketTypeListFn)(row[column.id], column, ticketTypes);
      }
      if (column.type === "devicesAndGroups") {
        return (0, _device.formatDeviceNameAndTagName)(row[column.id], column, devicesMap);
      }

      // $FlowFixMe
      return (0, _Formatters.createValueFormatter)({
        translate: translate,
        time: time,
        devices: devices,
        plantStateActivities: plantStateActivities,
        ticketTypes: ticketTypes,
        users: users
      })(column, row[column.id]);
    }
    return row[column.id];
  };
}